import axios from "../../utils/axios";
import {CONFIG} from "../../config";

export async function getBackofficeUser(email: string) {
    const res = await axios.get(`${CONFIG.SERVICES_ADMIN_URL}/api/v1/backoffice/user?email=${email}`)
    return res.data as BackofficeUser
}

const BACKOFFICE_USERS = `${CONFIG.SERVICES_ADMIN_URL}/api/v1/admin/backoffice-users`

export async function listBackofficeUsers(params: {q?: string, page: number, pageSize: number}) {
    const res = await axios.get(BACKOFFICE_USERS, {params})
    return res.data as BackofficeUserPage
}

export async function createBackofficeUser(payload: CreateBackofficeUserPayload) {
    const res = await axios.post(BACKOFFICE_USERS, payload)
    return res.data as AdminBackofficeUser
}

export async function replaceBackofficeUserRoles(userId: string, roles: BackofficeRoleGrant[]) {
    const res = await axios.put(`${BACKOFFICE_USERS}/${userId}/roles`, {roles})
    return res.data as AdminBackofficeUser
}

export async function deleteBackofficeUser(userId: string) {
    await axios.delete(`${BACKOFFICE_USERS}/${userId}`)
}

export function backofficeErrorMessage(error: any): string {
    const description = error?.response?.data?.description
    if (description) {
        return description
    }
    if (error?.response?.status === 401) {
        return "Only admin dashboard editors can change backoffice users."
    }
    return error?.message ?? "Request failed."
}

export interface BackofficeUserPage {
    data: AdminBackofficeUser[]
    total: number
    currentPage: number
    lastPage: number
    pageSize: number
}

export interface AdminBackofficeUser {
    primaryId: string
    email: string
    firstName: string
    lastName: string
    createdAt: string
    roles: (BackofficeRoleGrant & {primaryId: string})[]
}

export interface BackofficeRoleGrant {
    roleScope: BackofficeRoleScope
    roleName: BackofficeRoleName
}

export interface CreateBackofficeUserPayload {
    email: string
    firstName: string
    lastName: string
    roles: BackofficeRoleGrant[]
}

export interface BackofficeUser {
    /**
     * uuid
     */
    primary_id: string
    email: string
    first_name: string
    last_name: string
    roles: BackofficeRoles[]
}

export interface BackofficeRoles {
    /**
     * uuid
     */
    primary_id: string
    role_scope: BackofficeRoleScope
    role_name: BackofficeRoleName
}

export enum BackofficeRoleName {
    SUPERADMIN = 'superadmin',
    USER = 'user',
    EDITOR = 'editor',
    VIEWER = 'viewer',
}

export enum BackofficeRoleScope {
    B2B_PORTAL = 'b2b_portal',
    ADMIN_DASHBOARD = 'admin_dashboard',
}
